export default __webpack_public_path__ + "static/media/play.fb6a588a.svg";